import { Box } from '@material-ui/core';

import { useCustomTheme } from '../../../../../hooks/useCustomTheme';

export const ErrorSuccessStatusIndicator = ({ value }: { value: boolean }) => {
  const { palette } = useCustomTheme();
  return (
    <Box
      display={'inline-flex'}
      alignSelf={'center'}
      height={'10px'}
      width={'10px'}
      ml={'6px'}
      borderRadius={'10px'}
      bgcolor={value ? palette.success.main : palette.error.main}
    />
  );
};
